import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { PanelLoader, useGetCrumbs } from "../../../../../features/ui"
import { operationHelpers } from "../../../../operations"
import { HoardOrder, HoardType } from "../../../state/types"
import { IncreaseHoardForm } from "./increaseHoardForm"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"

export const IncreaseHoardFormLoader = () => {
    const { dataType } = useRoutesHooks().parseUrl()
    const hoard = dataType! as HoardOrder

    const [ready, setReady] = useState(false)
    const navigate = useNavigate()
    const { getRoutePath } = useRoutesHooks()
    const { describeCode } = operationHelpers

    useEffect(() => {
        if (hoard.type !== HoardType.FINANCIAL) {
            navigate(getRoutePath(RoutePath.HOARDS, hoard.id))
        } else {
            setReady(true)
        }
    }, [])

    const crumbs = useGetCrumbs(
        'Acopios',
        RoutePath.HOARDS,
        describeCode(hoard),
        hoard.id,
        'Ampliar Acopio'
    )

    return (
        <PanelLoader
            title={`Ampliar Acopio - ${describeCode(hoard)}`}
            crumbs={crumbs}
            ready={ready}
        >
            <IncreaseHoardForm hoard={hoard} />
        </PanelLoader>
    )
}
